export const SOFTLINE_PERMISSION_TRANSPORTAUFTRAG = 'TRANSPORTAUFTRAG';
export const SOFTLINE_PERMISSION_TRANSPORTAUFTRAG_SUBMIT_LIEFERSCHEIN =
  'TRANSPORTAUFTRAG.LIEFERSCHEIN';
export const SOFTLINE_PERMISSION_TRANSPORTAUFTRAG_SUBMIT_INVOICE =
  'TRANSPORTAUFTRAG.KREDITRECHNUNG';
